"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _placeholder = _interopRequireDefault(require("./placeholder"));

var _rowKebabMenu = _interopRequireDefault(require("./../row-kebab-menu"));

var _CircularProgress = _interopRequireDefault(require("@eig-builder/core-ui/CircularProgress"));

var _Grid = _interopRequireDefault(require("@eig-builder/core-ui/Grid"));

var _Button = _interopRequireDefault(require("@eig-builder/core-ui/Button"));

var _taggingHelper = require("@eig-builder/core-utils/helpers/tagging-helper");

var _usePrevious = _interopRequireDefault(require("@eig-builder/core-utils/hooks/usePrevious"));

var displayHelpers = _interopRequireWildcard(require("../table-display-helpers"));

var _frameworkComponents = _interopRequireDefault(require("../framework-components"));

var _startCase = _interopRequireDefault(require("lodash/startCase"));

var _toLower = _interopRequireDefault(require("lodash/toLower"));

var _isNil = _interopRequireDefault(require("lodash/isNil"));

var _isEqual = _interopRequireDefault(require("lodash/isEqual"));

var _uniqBy = _interopRequireDefault(require("lodash/uniqBy"));

var _dataGridContext = _interopRequireDefault(require("../../../data-grid-context"));

var _react2 = require("@ag-grid-community/react");

require("@ag-grid-community/all-modules/dist/styles/ag-grid.css");

require("@ag-grid-community/all-modules/dist/styles/ag-theme-material.css");

require("./style/styles.scss");

var _useDebounce3 = _interopRequireDefault(require("../../../hooks/useDebounce"));

var _views = require("./views");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var fitTableToScreenSize = function fitTableToScreenSize(gridApi, columnApi) {
  var currentRef = columnApi && columnApi.containerRef.current;
  var containerRect = currentRef && currentRef.getBoundingClientRect();
  var gridWidth = columnApi && columnApi.getColumnState().filter(function (column) {
    return column.hide !== true;
  }).reduce(function (a, b) {
    return a + b.width;
  }, 0);

  if (!currentRef || gridWidth < window.innerWidth && gridWidth < containerRect.width) {
    if (gridApi && gridApi.sizeColumnsToFit) {
      gridApi.sizeColumnsToFit();
    }
  } else {
    columnApi.autoSizeColumns();
  }
};

var statusFormat = function statusFormat(param) {
  return (0, _startCase["default"])((0, _toLower["default"])(param.value));
};

var checkFormat = function checkFormat(param) {
  return param.value ? /*#__PURE__*/_react["default"].createElement(_views.CheckBox, {
    icon: "check"
  }) : null;
};

var Table = function Table(_ref) {
  var setRearrange = _ref.setRearrange,
      rowDragManaged = _ref.rowDragManaged,
      isRightViewActive = _ref.isRightViewActive,
      cellClick = _ref.cellClick,
      sortChangeHandler = _ref.sortChangeHandler,
      dndSortEndHandler = _ref.dndSortEndHandler,
      isDnd = _ref.isDnd,
      subscribePagination = _ref.subscribePagination,
      detailUrl = _ref.detailUrl,
      editableGrid = _ref.editableGrid,
      columnDefs = _ref.columnDefs,
      multiSelect = _ref.multiSelect,
      getKebabMenuOptions = _ref.getKebabMenuOptions,
      pinKebabMenu = _ref.pinKebabMenu,
      rowData = _ref.rowData,
      defaultSortModel = _ref.defaultSortModel,
      domLayout = _ref.domLayout,
      frameworkComponents = _ref.frameworkComponents,
      placeholderHeight = _ref.placeholderHeight,
      rowHeight = _ref.rowHeight,
      rowSelection = _ref.rowSelection,
      selectedActions = _ref.selectedActions,
      onGridReady = _ref.onGridReady,
      onSelectedNode = _ref.onSelectedNode,
      onClickFunc = _ref.onClickFunc,
      suppressRowClickSelection = _ref.suppressRowClickSelection,
      suppressCellSelection = _ref.suppressCellSelection,
      noRowsMessage = _ref.noRowsMessage,
      paginationPageSize = _ref.paginationPageSize,
      getRowNodeId = _ref.getRowNodeId,
      rowModelType = _ref.rowModelType,
      autocompleteValues = _ref.autocompleteValues,
      enableCellTextSelection = _ref.enableCellTextSelection,
      serverSidePagination = _ref.serverSidePagination,
      tableHeight = _ref.tableHeight,
      datasource = _ref.datasource,
      gridData = _ref.gridData,
      restProps = (0, _objectWithoutProperties2["default"])(_ref, ["setRearrange", "rowDragManaged", "isRightViewActive", "cellClick", "sortChangeHandler", "dndSortEndHandler", "isDnd", "subscribePagination", "detailUrl", "editableGrid", "columnDefs", "multiSelect", "getKebabMenuOptions", "pinKebabMenu", "rowData", "defaultSortModel", "domLayout", "frameworkComponents", "placeholderHeight", "rowHeight", "rowSelection", "selectedActions", "onGridReady", "onSelectedNode", "onClickFunc", "suppressRowClickSelection", "suppressCellSelection", "noRowsMessage", "paginationPageSize", "getRowNodeId", "rowModelType", "autocompleteValues", "enableCellTextSelection", "serverSidePagination", "tableHeight", "datasource", "gridData"]);

  var _useState = (0, _react.useState)(null),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      columnApi = _useState2[0],
      setColumnApi = _useState2[1];

  var _useState3 = (0, _react.useState)([]),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      transformedHeaders = _useState4[0],
      setTransformedHeaders = _useState4[1];

  var _useState5 = (0, _react.useState)(null),
      _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
      moveRowStartIndex = _useState6[0],
      setMoveRowStartIndex = _useState6[1];

  var _useDebounce = (0, _useDebounce3["default"])('', 500),
      _useDebounce2 = (0, _slicedToArray2["default"])(_useDebounce, 2),
      ssSearchQuery = _useDebounce2[0],
      setSsSearchQuery = _useDebounce2[1];

  var _useContext = (0, _react.useContext)(_dataGridContext["default"]),
      showTable = _useContext.showTable,
      searchQuery = _useContext.searchQuery,
      filters = _useContext.filters,
      categoryFilters = _useContext.categoryFilters,
      selectedNodes = _useContext.selectedNodes,
      setSelectedNodes = _useContext.setSelectedNodes,
      gridApi = _useContext.gridApi,
      setGridApi = _useContext.setGridApi;

  var refContainer = (0, _react.useRef)();
  var multiSelectHeader = {
    headerCheckboxSelection: !serverSidePagination,
    checkboxSelection: true,
    width: (isDnd && !selectedNodes.length || isRightViewActive) && multiSelect ? 110 : 75,
    suppressMenu: true,
    pinned: 'left',
    suppressSizeToFit: true,
    rowDrag: isDnd && multiSelect && !isRightViewActive && !selectedNodes.length,
    rowDragManaged: rowDragManaged,
    dndSource: isRightViewActive,
    dndSourceOnRowDrag: isRightViewActive ? displayHelpers.onRowDrag : null,
    valueGetter: function valueGetter(params) {
      return '';
    },
    headerName: ''
  };
  var filteredData = rowData;

  if (Array.isArray(filters) && filters.length) {
    var cumulativeFilteredData = filters.map(function (filterItem) {
      return filterItem.query(rowData);
    }).flat();
    filteredData = (0, _uniqBy["default"])(cumulativeFilteredData, 'id');
  } else if (filters && filters.query) {
    if (serverSidePagination) {
      datasource.onFilterChanged(filters === null || filters === void 0 ? void 0 : filters.filter);
    } else {
      filteredData = filters.query(rowData);
    }
  }

  if (Array.isArray(categoryFilters) && categoryFilters.length) {
    var _cumulativeFilteredData = categoryFilters.map(function (filterItem) {
      return filterItem.query(filteredData);
    }).flat();

    filteredData = (0, _uniqBy["default"])(_cumulativeFilteredData, 'id');
  }

  var previousFilteredData = (0, _usePrevious["default"])(filteredData);
  (0, _react.useEffect)(function () {
    if (gridApi) {
      gridApi.context.query = searchQuery;
      gridApi.onFilterChanged();
    }
  }, [ssSearchQuery, gridApi]);
  (0, _react.useEffect)(function () {
    if (gridApi !== null && columnApi !== null) {
      // resize
      fitTableToScreenSize(gridApi, columnApi);
      window.addEventListener('resize', fitTableToScreenSize(gridApi, columnApi)); // sort and sort dependent DnD

      var defaultSortingModel = Array.isArray(defaultSortModel) ? defaultSortModel : defaultSortModel ? [defaultSortModel] : [];

      if (defaultSortingModel.length > 0) {
        gridApi.setSortModel(defaultSortingModel);

        if (isDnd) {
          gridApi.setSuppressRowDrag(true);
        }
      } else {
        gridApi.setSortModel([]);
        gridApi.setSuppressRowDrag(false);
      }
    }
  }, [gridApi, columnApi, defaultSortModel]); // Update grid by searchQuery

  (0, _react.useEffect)(function () {
    if (gridApi && serverSidePagination) {
      setSsSearchQuery(searchQuery);
    } else if (gridApi && (0, _isNil["default"])(searchQuery) === false) {
      gridApi.setQuickFilter(searchQuery);
    }
  }, [gridApi, searchQuery]); // Update grid by auto complete

  (0, _react.useEffect)(function () {
    if (gridApi && autocompleteValues) {
      gridApi.forEachNode(function (node) {
        var shouldBeSelected = !!autocompleteValues.find(function (item) {
          return item.id === node.data.id;
        });
        node.setSelected(shouldBeSelected);
      });
    }
  }, [autocompleteValues, gridApi]); // Update grid by resizing window

  (0, _react.useEffect)(function () {
    if (gridApi && columnApi) {
      if (showTable) {
        fitTableToScreenSize(gridApi, columnApi);
      } else {
        window.removeEventListener('resize', fitTableToScreenSize(gridApi, columnApi));
      }
    }
  }, [columnApi, gridApi, showTable]); // Update grid deselecting selected nodes

  (0, _react.useEffect)(function () {
    if (filteredData && previousFilteredData && filteredData.length !== previousFilteredData.length) {
      deselectNodes();
    }
  }, [filteredData, previousFilteredData]);
  (0, _react.useEffect)(function () {
    var headers = columnDefs && columnDefs.map(function (column) {
      return column.checkboxSelection && rowSelection ? _objectSpread(_objectSpread({}, column), {}, {
        cellClass: 'pl-2'
      }) : column;
    }).map(function (column) {
      return _objectSpread(_objectSpread({}, column), {}, {
        suppressMenu: true
      });
    }); // header transformations for data that used the old module-data-table

    if (editableGrid && columnDefs && headers) {
      headers = displayHelpers.transformOldTableData(headers);
    } // set transformed headers


    setTransformedHeaders(headers);
  }, [columnDefs]); // Grid is rendered setGridApi, setColumnApi

  var handleOnGridReady = (0, _react.useCallback)(function (event) {
    if (gridApi === null && columnApi === null) {
      event.columnApi.containerRef = refContainer;
      setGridApi(event.api);
      setColumnApi(event.columnApi); // Call prop onGridReady func

      if (onGridReady && typeof onGridReady === 'function') {
        onGridReady(event);
      }
    }
  }, [gridApi, columnApi, refContainer, setGridApi, setColumnApi, onGridReady]);

  var deselectNodes = function deselectNodes() {
    setSelectedNodes([]);
    gridApi && gridApi.deselectAll();
  };

  var onSelectionChanged = (0, _react.useCallback)(function (event) {
    var selectedNodes = event.api.getSelectedNodes();
    var selectedNodesData = selectedNodes.map(function (item) {
      return item.data;
    });

    if (isDnd && selectedNodesData.length) {
      setRearrange(false);
    }

    setSelectedNodes(selectedNodesData);

    if (typeof onSelectedNode === 'function') {
      onSelectedNode(selectedNodesData);
    }
  }, [setSelectedNodes, onSelectedNode, isDnd, setRearrange]);
  var onCellClick = (0, _react.useCallback)(function (event) {
    if (cellClick && typeof cellClick === 'function') {
      cellClick(event);
    }
  }, [cellClick]);
  var onRowClick = (0, _react.useCallback)(function (event) {
    var nodes = event.api.getSelectedNodes();

    if (nodes.length === 0 && onClickFunc) {
      var className = "".concat(event.event.target.className);

      if (event.event.target.localName !== 'button' && (className.startsWith('ag-react-container') || className.startsWith('ag-cell') || className === '')) {
        onClickFunc(event.data);
      }
    } else {
      if (event.node.selected) {
        event.node.setSelected(false);
      } else {
        event.node.setSelected(true);
      }
    }
  }, [onClickFunc]);
  var onRowDragStart = (0, _react.useCallback)(function (event) {
    // save initial index on state as it gets overwritten on the api
    setMoveRowStartIndex(event.node.childIndex);
  }, [setMoveRowStartIndex]);
  var onRowDragMove = (0, _react.useCallback)(function (event) {
    var currentPage = event.api.paginationGetCurrentPage();
    var movingNode = event.node;
    var overNode = event.overNode;
    var movingData = movingNode.data;
    var overData = overNode.data;
    var fromIndex = filteredData.indexOf(movingData);
    var indexOnFirstPage = filteredData.indexOf(overData);
    var toIndex = indexOnFirstPage + currentPage * paginationPageSize;
    var rowNeedsToMove = fromIndex !== toIndex;

    if (rowNeedsToMove) {
      var newStore = filteredData.slice();
      moveInArray(newStore, fromIndex, toIndex);
      filteredData = newStore;
      gridApi.setRowData(newStore);
      gridApi.clearFocusedCell();
    }

    function moveInArray(arr, fromIndex, toIndex) {
      var element = arr[fromIndex];
      arr.splice(fromIndex, 1);
      arr.splice(toIndex, 0, element);
    }
  }, [filteredData, paginationPageSize, gridApi]);
  var onRowDragEnd = (0, _react.useCallback)(function (params) {
    if (dndSortEndHandler && typeof dndSortEndHandler === 'function') {
      dndSortEndHandler(params, moveRowStartIndex);
    }

    setMoveRowStartIndex(null);
  }, [dndSortEndHandler, setMoveRowStartIndex]);
  var onSortChanged = (0, _react.useCallback)(function (params) {
    if (sortChangeHandler && typeof sortChangeHandler === 'function') {
      var newSortModel = params.api.getSortModel();

      if (!(0, _isEqual["default"])(defaultSortModel, newSortModel)) {
        sortChangeHandler(newSortModel);
      }
    }
  }, [sortChangeHandler, defaultSortModel]);
  var getEditMenu = (0, _react.useCallback)(function (node) {
    var _node$data;

    var menuOptions = getKebabMenuOptions(node.data);

    if (!menuOptions) {
      return null;
    }

    var filteredOptions = menuOptions.filter(function (option) {
      return !option.hidden;
    }); // If there are no menu options, don't show kebabmenu

    if (filteredOptions.length === 0) {
      return null;
    }

    return /*#__PURE__*/_react["default"].createElement(_rowKebabMenu["default"], {
      actionCallback: deselectNodes,
      item: node === null || node === void 0 ? void 0 : node.data,
      menuIdentifier: node === null || node === void 0 ? void 0 : (_node$data = node.data) === null || _node$data === void 0 ? void 0 : _node$data.id,
      options: filteredOptions,
      pinRowKebabMenu: pinKebabMenu
    });
  }, [getKebabMenuOptions, deselectNodes]); // No rows to show template

  var overlayNoRowsTemplate = (0, _react.useMemo)(function () {
    return "<span style=\"margin-top: 20px\">".concat(noRowsMessage, "</span>"); //eslint-disable-line
  }, [noRowsMessage]);
  var showPagination = (0, _react.useCallback)(function () {
    if (rowModelType === 'infinite') {
      return false;
    }

    return paginationPageSize > 0 && filteredData && filteredData.length > paginationPageSize;
  }, [rowModelType, paginationPageSize, filteredData]);

  var editableGridFrameworkComponents = _objectSpread({
    dragDropFormat: _frameworkComponents["default"].DragDropFormat,
    checkboxFormat: _frameworkComponents["default"].CheckboxFormat,
    checkboxDisableFormat: _frameworkComponents["default"].CheckboxDisableFormat,
    dateFormat: _frameworkComponents["default"].DateFormat,
    dateTimeFormat: _frameworkComponents["default"].DateTimeFormat,
    displayImage: _frameworkComponents["default"].DisplayImage,
    iconFormat: _frameworkComponents["default"].IconFormat,
    editFieldFormat: _frameworkComponents["default"].EditFieldFormat,
    buttonFieldFormat: _frameworkComponents["default"].ButtonFieldFormat,
    dangerouslyDisplayRawHTML: _frameworkComponents["default"].DangerouslyDisplayRawHTML,
    priceFormat: _frameworkComponents["default"].PriceFormat,
    priceFormatTotal: _frameworkComponents["default"].PriceFormatTotal,
    calcPricePercentageFormat: _frameworkComponents["default"].CalcPricePercentageFormat,
    percentageFormat: _frameworkComponents["default"].PercentageFormat,
    displayImageCheckDescriptionFormat: _frameworkComponents["default"].DisplayImageCheckDescriptionFormat,
    commaSeparateFormat: _frameworkComponents["default"].CommaSeparateFormat,
    visibleFormat: _frameworkComponents["default"].VisibleFormat,
    getKebabFormat: _frameworkComponents["default"].GetKebabFormat,
    tagsFormat: _frameworkComponents["default"].TagsFormat,
    displayBackgroundColor: _frameworkComponents["default"].DisplayBackgroundColor,
    concatFormat: _frameworkComponents["default"].ConcatFormat,
    localListFormat: _frameworkComponents["default"].LocalListFormat,
    messageFormat: _frameworkComponents["default"].MessageFormat,
    urlFormat: _frameworkComponents["default"].UrlFormat,
    getDefault: _frameworkComponents["default"].GetDefault,
    getCategories: _frameworkComponents["default"].GetCategories,
    dragRightView: _frameworkComponents["default"].DragRightView,
    editMenu: getEditMenu,
    check: checkFormat
  }, frameworkComponents);

  var domLayoutType = rowModelType === 'infinite' ? 'normal' : domLayout;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_views.CardTable, {
    showTable: showTable
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: onClickFunc ? 'ag-table-clickable' : ''
  }, selectedNodes.length > 0 && selectedActions.length > 0 && /*#__PURE__*/_react["default"].createElement(_views.OverlayBar, null, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
    container: true,
    spacing: 2
  }, selectedActions.map(function (action) {
    return /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
      key: action.tag,
      item: true
    }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
      variant: "outlined",
      onClick: function onClick() {
        return action.func(selectedNodes);
      },
      dataElementLocation: _taggingHelper.DataElementLocations.BODY,
      dataElementLabel: "data-grid-body-table-action-button-".concat(action.tag),
      dataElementId: "data-grid-body-table-action-button-".concat(action.tag)
    }, action.label));
  }))), (filteredData || serverSidePagination) && /*#__PURE__*/_react["default"].createElement(_views.AgMaterial, {
    className: "ag-theme-material",
    ref: refContainer,
    tableHeight: tableHeight
  }, /*#__PURE__*/_react["default"].createElement(_react.Suspense, {
    fallback: /*#__PURE__*/_react["default"].createElement(_CircularProgress["default"], {
      centered: true,
      withPadding: true
    })
  }, /*#__PURE__*/_react["default"].createElement(_react2.AgGridReact, (0, _extends2["default"])({
    onGridReady: handleOnGridReady,
    columnDefs: multiSelect ? [multiSelectHeader].concat((0, _toConsumableArray2["default"])(transformedHeaders)) : transformedHeaders,
    rowData: filteredData,
    overlayNoRowsTemplate: overlayNoRowsTemplate,
    rowHeight: rowHeight,
    rowSelection: multiSelect ? 'multiple' : rowSelection,
    suppressPropertyNamesCheck: true,
    reactNext: true,
    domLayout: domLayoutType,
    suppressRowClickSelection: suppressRowClickSelection,
    suppressCellSelection: suppressCellSelection,
    onSelectionChanged: onSelectionChanged,
    components: {
      date: function date(params) {
        return params.value;
      },
      statusFormat: statusFormat
    },
    frameworkComponents: editableGrid ? editableGridFrameworkComponents : _objectSpread({
      editMenu: getEditMenu,
      check: checkFormat
    }, frameworkComponents),
    onRowClicked: suppressRowClickSelection ? null : onRowClick,
    onCellClicked: suppressCellSelection ? null : onCellClick,
    pagination: showPagination(),
    paginationPageSize: paginationPageSize,
    onPaginationChanged: subscribePagination,
    getRowNodeId: getRowNodeId,
    rowModelType: rowModelType,
    enableCellTextSelection: enableCellTextSelection,
    cacheQuickFilter: true,
    onRowDragEnter: onRowDragStart,
    onRowDragMove: onRowDragMove,
    onRowDragEnd: onRowDragEnd,
    onSortChanged: onSortChanged,
    animateRows: true,
    immutableData: true,
    deltaColumnMode: true,
    suppressPaginationPanel: serverSidePagination
  }, restProps)))), !filteredData && !serverSidePagination && /*#__PURE__*/_react["default"].createElement(_placeholder["default"], {
    height: placeholderHeight
  }))));
};

Table.propTypes = {
  editableGrid: _propTypes["default"].bool,
  autocompleteValues: _propTypes["default"].array,
  columnDefs: _propTypes["default"].array.isRequired,
  datasource: _propTypes["default"].object.isRequired,
  defaultSortModel: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].object), _propTypes["default"].object]),
  domLayout: _propTypes["default"].string,
  frameworkComponents: _propTypes["default"].object,
  getKebabMenuOptions: _propTypes["default"].func,
  gridData: _propTypes["default"].object,
  pinKebabMenu: _propTypes["default"].bool,
  getRowNodeId: _propTypes["default"].func,
  multiSelect: _propTypes["default"].bool,
  noRowsMessage: _propTypes["default"].string,
  onClickFunc: _propTypes["default"].func,
  onGridReady: _propTypes["default"].func,
  onSelectedNode: _propTypes["default"].func,
  paginationPageSize: _propTypes["default"].number,
  placeholderHeight: _propTypes["default"].number,
  rowData: _propTypes["default"].array,
  rowHeight: _propTypes["default"].number,
  rowModelType: _propTypes["default"].string,
  rowSelection: _propTypes["default"].string,
  selectedActions: _propTypes["default"].array,
  suppressRowClickSelection: _propTypes["default"].bool,
  suppressCellSelection: _propTypes["default"].bool,
  enableCellTextSelection: _propTypes["default"].bool,
  detailUrl: _propTypes["default"].string,
  detailClick: _propTypes["default"].func,
  cellClick: _propTypes["default"].func,
  subscribePagination: _propTypes["default"].func,
  rowDragManaged: _propTypes["default"].bool,
  sortChangeHandler: _propTypes["default"].func,
  sorting: _propTypes["default"].array,
  isDnd: _propTypes["default"].bool,
  isRightViewActive: _propTypes["default"].bool,
  dndSortEndHandler: _propTypes["default"].func,
  persistentFilters: _propTypes["default"].array,
  storeCategoryFilter: _propTypes["default"].array,
  allStoreCategories: _propTypes["default"].array,
  serverSidePagination: _propTypes["default"].bool,
  tableHeight: _propTypes["default"].any,
  setRearrange: _propTypes["default"].func
};
Table.defaultProps = {
  rowDragManaged: false,
  domLayout: 'autoHeight',
  placeholderHeight: 300,
  rowHeight: 52,
  selectedActions: [],
  suppressRowClickSelection: true,
  enableCellTextSelection: true,
  noRowsMessage: 'No rows to show',
  serverSidePagination: false,
  rowModelType: 'clientSide',
  getRowNodeId: function getRowNodeId(data) {
    return data.id;
  }
};
var _default = Table;
exports["default"] = _default;